module.exports = __webpack_public_path__ + "r-v3/img/arrowDown_white.15b86234.svg";